<template>
    <core-modal
        v-model="isOpen"
        :title="t('financeSelinaModal.title')"
        :subtitle="t('financeSelinaModal.subtitle')"
        :show-cancel-button="true"
        :cancel-label="t('financeSelinaModal.cancel')"
        :footer-within-content="xs"
        @close="isOpen = false"
        @cancel="isOpen = false"
    >
        <i18n-t keypath="financeSelinaModal.body" tag="p" class="mb-3 mx-2">
            <template #amount>
                <span class="bold-text">
                    {{
                        formatAmountBasedOnLocaleAndCurrency(
                            language,
                            localCurrency,
                            localAmount,
                        )
                    }}
                </span>
            </template>
        </i18n-t>

        <div
            v-for="feature in financeSelinaFeatureKeys"
            :key="feature"
            class="mb-3 mx-2"
        >
            <p class="bold-text mb-1">
                {{ t(`financeSelinaModal.features.${feature}.icon`) }}
                {{ t(`financeSelinaModal.features.${feature}.title`) }}
            </p>
            <p class="mb-0">
                {{ t(`financeSelinaModal.features.${feature}.description`) }}
            </p>
        </div>

        <template v-if="xs">
            <v-divider class="mx-n4" />
            <h4 class="small-text secondary-text mt-2 mx-2">
                {{ t("financeSelinaModal.representativeExampleTitle") }}
            </h4>
            <p class="small-text secondary-text mt-2 mx-2">
                {{ t("financeSelinaModal.representativeExampleText") }}
            </p>
            <p class="small-text secondary-text mt-2 mx-2">
                {{ t("financeSelinaModal.legalText") }}
            </p>
        </template>

        <template #action>
            <core-button
                colour="primary"
                :append-icon="mdiOpenInNew"
                data-cy="finance-selina-cta"
                @click="handleSelinaRedirect"
                class="mx-2"
            >
                {{ t("financeSelinaModal.cta") }}
            </core-button>
        </template>

        <template v-if="smAndUp" #footer-text>
            <v-divider class="mx-n4" />
            <h4 class="small-text secondary-text mt-2 mx-2">
                {{ t("financeSelinaModal.representativeExampleTitle") }}
            </h4>
            <p class="small-text secondary-text mt-2 mx-2">
                {{ t("financeSelinaModal.representativeExampleText") }}
            </p>
            <p class="small-text secondary-text mt-2 mx-2">
                {{ t("financeSelinaModal.legalText") }}
            </p>
        </template>
    </core-modal>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { mdiOpenInNew } from "@mdi/js";
import { CoreModal, CoreButton } from "@esenda/core-ui";
import { formatAmountBasedOnLocaleAndCurrency } from "@/helpers/amountProcessors";
import { useDisplay } from "vuetify";

const componentProps = defineProps<{
    language: string;
    localCurrency: string;
    localAmount: string | number;
}>();

const isOpen = defineModel<boolean>({ required: true });

const { t } = useI18n();
const { xs, smAndUp } = useDisplay();

const selinaQuoteUrl =
    "https://newquote.selinafinance.co.uk/?utm_source=affiliates&utm_medium=partner&utm_campaign=esenda_partner_prospecting_esenda";
const financeSelinaFeatureKeys = ["borrow", "terms", "rates", "fastDecisions"];

function handleSelinaRedirect() {
    isOpen.value = false;
    window.open(selinaQuoteUrl, "_blank", "noopener,noreferrer");
}
</script>
